import React from 'react';
import { withAppContext } from 'src/store/initAppContext';
import Footer31 from './footer31';
import OtherBrandsFooter from './footer-other-brands';

function FooterContainer(props: any) {
    const { app: { brandId } } = props;
    return brandId === 31 || brandId === 32 
        ? <Footer31 />
        : <OtherBrandsFooter />;
}

export default withAppContext(FooterContainer);
